<template>
  <div class="zhenyun-nav-wrapper" v-if="showLeftNav">
    <div class="inner-content">
      <div
        class="menu-list-nav"
        v-for="(navItem, navIndex) in matchZhenyunRouters"
        :key="navIndex"
      >
        <p class="nav-1-title">{{ navItem.meta.title }}</p>
        <div
          class="menu-nav-item-list"
          v-for="(nav1, navIndex1) in navItem.children"
          :key="nav1.path + navIndex1"
          @click="handleRouterPush(nav1)"
        >
          <div
            class="nav-2-box"
            :class="nav1.meta.fullPath === activeFullPath ? 'cur-nav-item' : ''"
            v-show="nav1.meta.isShowNav !== false"
          >
            <p class="nav-2-title">
              <span>{{ nav1.meta.title }}</span>
              <span class="nav-number">{{ numMap[nav1.meta.numKey]}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import zhenyunPageRouters from '@/router/zhenyun-page'
import { zoologyNum } from '@/utils/api/dashboard';
import { mapActions,mapState } from 'vuex'
export default {
  name: 'zhenyun-nav',
  props: [],
  data() {
    return {
      matchZhenyunRouters: zhenyunPageRouters,
      // numMap:{
      //   agreementsNum:'',
      //   canQuoteRfqNum:'',
      //   totalQuoteNum:'',
      // }
    }
  },
  methods: {
    ...mapActions('zhenyunStore',['getZhenyunLevelLength']),
    handleRouterPush(route) {
      //其他跳转逻辑，后续在这里处理即可
      this.$router.push(route.meta.fullPath)
    },
  },
  mounted() {
    this.getZhenyunLevelLength()
    this.matchZhenyunRouters = this.matchZhenyunRouters.filter(k=>k.meta.isShowNav!==false)
  },
  computed: {
    ...mapState('zhenyunStore', ['numMap']),
    activeFullPath() {
      const currentPath = this.$route.meta.currentMenuItem
        ? this.$route.meta.currentMenuItem
        : this.$route.path
      let targetPath = currentPath
      this.matchZhenyunRouters.forEach((parentNav) => {
        parentNav.children?.forEach((childNav) => {
          if (
            childNav.meta?.fullPath === currentPath &&
            childNav.meta?.currentMenuItem
          ) {
            targetPath = childNav.meta.currentMenuItem
          }
        })
      })
      return targetPath
    },
    showLeftNav() {
      if (this.$route.meta.isShowLeftNavgation === false) {
        return false
      }
      return true
    },
  },
}
</script>

<style scoped lang="scss">
/* SCSS or CSS here */
.zhenyun-nav-wrapper {
  background-color: #fff;
  width: 180px;
  height: calc(100vh - 72px);
  .inner-content {
    padding: 16px 8px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    .menu-list-nav {
      .nav-1-title {
        display: flex;
        padding: 5px 4px;
        align-items: center;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        color: #222222;
        text-overflow: ellipsis;
        font-family: SourceHanSansCN-Bold;
        font-size: 14px;
        font-style: normal;
        // font-weight: 700;
        line-height: 22px;
        position: relative;
        margin-bottom: 8px;
      }
      .nav-1-title::before {
        content: '';
        width: 2px;
        height: 12px;
        background: #0863ff;
        display: inline-block;
        margin-right: 4px;
      }
      .menu-nav-item-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
        .nav-2-box {
          display: flex;
          padding: 5px 10px;
          justify-content: space-between;
          align-items: center;
          align-self: stretch;
          border-radius: 2px;
          // background: #f5f7fa;
          .nav-2-title {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            color: #222222;
            text-overflow: ellipsis;
            font-family: SourceHanSansCN-Regular;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            width: 100%;
            .nav-number {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
              color: #98a3b7;
              text-overflow: ellipsis;
              font-family: SourceHanSansCN-Regular;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 22px;
            }
          }
        }
        .nav-2-box.cur-nav-item {
          background: #f5f7fa;
          .nav-2-title {
            color: #0863ff;
            text-overflow: ellipsis;
            font-family: SourceHanSansCN-Regular;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
          }
        }
      }
    }
  }
}
</style>
